// removed by extract-text-webpack-plugin
module.exports = {"loader":"styles__loader___3GHPe","image":"styles__image___r3Xtr","text":"styles__text___1NXAH"};


//////////////////
// WEBPACK FOOTER
// ./common/components/Loader/styles.scss
// module id = jnYD
// module chunks = 0